import { FieldLabel, FieldValue, Stack } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CustomerSearch } from '../../../../customer/customer-search/CustomerSearch'
import { LineItemFulfilmentCustomerHeaderView } from './LineItemFulfilmentCustomerHeaderView'

export type Props = {
  onAddNewCustomer: () => void
  onSelectCustomer: (customer: ApiCustomer | null) => void
}

export const LineItemFulfilmentAddCustomerView: React.FC<Props> = ({
  onAddNewCustomer,
  onSelectCustomer,
}) => {
  const t = useT()
  return (
    <Stack space={6}>
      <LineItemFulfilmentCustomerHeaderView />
      <FieldLabel label={t('Customer')}>
        <FieldValue>
          <CustomerSearch
            placeholder={t('Add a customer')}
            onAdd={onAddNewCustomer}
            onSelect={onSelectCustomer}
          />
        </FieldValue>
      </FieldLabel>
    </Stack>
  )
}
